import React, { useEffect, useState } from "react";
import { Table, Pagination, } from "react-bootstrap";
import {
  FiPlus, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { useDispatch, } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getClassSubject } from "../../store/slices/subject";
import { FiEdit } from "react-icons/fi";
import { toast } from "react-hot-toast";


export default function ClassSubject() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [classsubjectdata, setclasssubjectdata] = useState([]);

  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const fetchclassSubject = () => {
    dispatch(getClassSubject())
      .unwrap()
      .then((res) => {
        const subjectlist = res?.data || [];
        setclasssubjectdata(subjectlist);
        setTotalData(subjectlist.length);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to fetch classsubject");
        setclasssubjectdata([]);
      });
  };

  useEffect(() => {
    fetchclassSubject();
  }, []);


  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = classsubjectdata.slice(
    startIndex,
    startIndex + itemsPerPage
  );


  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>


            <FiChevronRight className="separator" />

            <span className="active">Class Subject</span>
          </div>

          <Link
            to="/institute/add-class-subject"
            className="add-btn"
          >
            <FiPlus />
            Add Class Subject
          </Link>

        </div>
      </div>

      <div className="staff-card">

        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Standard</th>
                <th className="text-center">Subject Name</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center p-3">
                    No class subjects found
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => (
                  <tr key={item._id}>

                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{item?.standardId?.name}</td>
                    <td>
                      {(() => {
                        const subjects = [
                          ...new Map(item.subjectId.map((sub) => [sub._id, sub])).values(),
                        ];

                        const rows = [];
                        for (let i = 0; i < subjects.length; i += 4) {
                          rows.push(subjects.slice(i, i + 4));
                        }

                        return rows.map((row, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-center mb-2"
                            style={{ gap: "8px" }}
                          >
                            {row.map((sub) => (
                              <span
                                key={sub._id}
                                className="subject-pill"
                              >
                                {sub.name}
                              </span>
                            ))}
                          </div>
                        ));
                      })()}
                    </td>

                    <td className="text-center">
                      <button
                        className="edit-btn"
                        onClick={() =>
                          navigate(`/institute/edit-class-subject/${item._id}`)
                        }
                      > <FiEdit size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div >
    </>

  );
}
